module.exports = __webpack_public_path__ + "static/logo-icon-f6768429ead54886ee8d5288dc058920.png";